import type { TrackingOptions, TrackingStrategies } from "./contracts";

export const DEFAULT_TRACKING_STRATEGIES: TrackingStrategies = {
  sparse: true,
  nano: true,
  hybrid: true,
};

export const DEFAULT_TRACKING_OPTIONS: TrackingOptions = {
  strategies: DEFAULT_TRACKING_STRATEGIES,
  nanoMode: "auto",
  maxRoiSize: 512,
  maxIntervalFrames: 240,
  maxIntervalBytes: 128 * 1024 * 1024,
  nanoModelUrls: {
    backbone: "/models/nanotrack/nanotrack_backbone.onnx",
    head: "/models/nanotrack/nanotrack_head.onnx",
    wasm: "https://cdn.jsdelivr.net/npm/onnxruntime-web@1.24.3/dist/",
  },
};
